export const formatCurrency = (value) =>
  typeof value === "number"
    ? value.toLocaleString("en-IN", { maximumFractionDigits: 0 })
    : "0";